module.exports = __webpack_public_path__ + "static/media/appointment_p3_2.8a91b069.png";